import { render, staticRenderFns } from "./EstablishmentContact.vue?vue&type=template&id=b09106ec&scoped=true"
import script from "./EstablishmentContact.vue?vue&type=script&lang=js"
export * from "./EstablishmentContact.vue?vue&type=script&lang=js"
import style0 from "./EstablishmentContact.vue?vue&type=style&index=0&id=b09106ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09106ec",
  null
  
)

export default component.exports